import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=dcb480ee&scoped=true"
import script from "./diagnosis.vue?vue&type=script&lang=ts"
export * from "./diagnosis.vue?vue&type=script&lang=ts"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=dcb480ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_hlqzqdj4q3cge46xolaszrvwji/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb480ee",
  null
  
)

export default component.exports